/* eslint-disable import/prefer-default-export */
import React from "react";
import styled from "styled-components";

const Tag = styled.span<{ $color: string }>`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 10px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: ${({ theme }) => theme.fontWeight.semibold};
  color: ${({ $color }) => $color};
  background: color-mix(in srgb, ${({ $color }) => $color} 14%, transparent);
  border: 1px solid
    color-mix(in srgb, ${({ $color }) => $color} 14%, transparent);
`;

export function PoiNearbyTag({ accentColor }: { accentColor: string }) {
  return <Tag $color={accentColor}>Perto de você</Tag>;
}
